import { gql } from 'apollo-angular';

export const CONTACT_PERSON_FRAGMENT = gql`
  fragment ContactPersonFragment on ContactPerson {
    id
    salutation
    firstName
    lastName
    email
    phone
    mobile
    fax
    isMain
  }
`;
